import React, { useState } from 'react'
import { HiMenuAlt4, HiX } from 'react-icons/hi'
import { motion } from 'framer-motion'
import './Navbar.scss'
import { images } from '../../constants';
// import images from '../../constants/images';
const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.logo} alt="Logo" />
      </div>
      <ul className='app_navbar-links'>
        {['home', 'about', 'contact', 'work', 'skills'].map((item) => (
          <li className='app__flex p-text' key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul> 

      {/*implement the hamburger navbar for mobile devices  */}
      <div className='app_navbar-menu'>
      <HiMenuAlt4 onClick={() => setToggle(true)} />
      {/* create a dynamic codeblock for the mobile menu */}
      {toggle && (
        //a special motion div that will animate the menu
         <motion.div
          whileInView={{x:[150,0]}} //menu from 300px to 0px
          transition={{duration:0.5, ease:'easeOut'}}
         >
          <HiX onClick={() => setToggle(false)} />
          <ul>
          {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
          <li  key={item}>
            <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
          </li>
        ))}
          </ul>

         </motion.div>
        )}</div>




    </nav>
  )
}

export default Navbar
